import {useQuery} from '@tanstack/react-query';
import {organizationService} from '../services/organization';

export function useOrganizationTree(rootId: number | string = 1) {
  return useQuery({
    queryKey: ['organization-tree', rootId],
    queryFn: () => organizationService.getTree(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
}